import classNames from 'classnames'
import getTitle from 'helpers/getTitle'
import Translate from 'modules/local/Translate'
import React, {useContext} from 'react'
import {NullAsDefault} from 'views/Shared'
import {renderIf, renderIfElse} from '../../../Shared'
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {Popover} from "antd";
import {GoDotFill} from "react-icons/go";
import {ItemInformation} from 'components/common/ItemInformation'
import {PiArrowFatLineRightFill, PiClock, PiClockFill} from "react-icons/pi";
import {renderFromToTime} from "../../../../helpers/datetimeHelpers";
import dayjs from "dayjs";

const Dates = ({to_date, from_date, isHappened}) =>
    renderIf(
        from_date || to_date,
        <div
            className={classNames("font-bold text-sm tracking-wider leading-tight", isHappened ? "text-color-300" : "text-green-600")}>
            {renderFromToTime(from_date, to_date)}
        </div>
    )

export const renderCourseClassTimetableDetail =
    ({renderContextMenu = NullAsDefault, displayAll} = {}) =>
        (item, index) => {
            const {isSm} = useContext(LayoutContext)
            const isHappened = dayjs(item?.end_time).isBefore(dayjs())
            const renderTime = (time) => (dayjs(time, 'HH:mm:ss').format('HH:mm'))
            const {subject, teacher, notes, start_time, end_time, location_address, attendances = [], days_of_week, is_holiday} = item ?? {}

            if (!!!displayAll && isHappened) return null;

            return (
                <Translate key={index}>
                    {(t) => (
                        <div
                            className={classNames('flex items-center w-full gap-2 custom-border-background rounded-r-full', isHappened && 'opacity-35')}>
                            <div className="w-full flex flex-col p-2 custom-item-child">
                                <div className="flex items-center gap-1 mb-2">
                                    {renderIfElse(
                                        isHappened,
                                        <PiClock size={17} className="text-color-200"/>,
                                        <PiClockFill size={17} className="text-green-300"/>
                                    )}
                                    <Dates from_date={start_time} to_date={end_time} isHappened={isHappened}/>
                                </div>
                                {renderIfElse(
                                    is_holiday === 1,
                                    <div className="flex flex-col">
                                        <div className="space-x-1">
                                            <PiArrowFatLineRightFill size={11} className="text-primary-300"/>
                                            <span
                                                className="font-medium text-sm text-primary-400 italic tracking-widest">
                                                {t('holiday')}
                                            </span>
                                        </div>
                                        {renderIf(
                                            notes,
                                            <div className="flex items-start gap-1 text-xs italic">
                                                <span
                                                    className="flex items-center gap-1 text-color-500 whitespace-no-wrap">
                                                    <GoDotFill size={10} className="text-color-500"/>
                                                    {`${t('note')} : `}
                                                </span>
                                                <span className="font-semibold text-color-100 whitespace-pre-line">
                                                    {notes}
                                                </span>
                                            </div>
                                        )}
                                    </div>,
                                    <div className="flex flex-col flex-1 ml-4">
                                        {renderIf(
                                            location_address,
                                            <ItemInformation primary={true} showIcon={true} label="locations"
                                                             value={location_address} className="text-xs italic"/>
                                        )}
                                        {renderIf(
                                            subject,
                                            <div className="flex-1 items-baseline gap-1">
                                                <GoDotFill size={10} className="text-color-400"/>
                                                <span className="text-xs text-color-500 whitespace-no-wrap italic">
                                                    {t('subjects')}
                                                </span>
                                                <span
                                                    className={classNames("font-bold", isHappened ? 'text-color-300' : 'text-blue-600')}>
                                                    {getTitle(subject)}
                                                </span>
                                            </div>
                                        )}
                                        {renderIf(
                                            teacher,
                                            <ItemInformation showIcon={true} label="teacher" value={getTitle(teacher)}
                                                             className="text-xs italic"/>
                                        )}
                                        {renderIf(
                                            notes,
                                            <div className="flex items-start gap-1 text-xs italic">
                                            <span className="flex items-center gap-1 text-color-500 whitespace-no-wrap">
                                                <GoDotFill size={10} className="text-color-500"/>
                                                {`${t('note')} : `}
                                            </span>
                                                <span className="font-semibold text-color-100 whitespace-pre-line">
                                                {notes}
                                            </span>
                                            </div>
                                        )}
                                        {renderIf(
                                            attendances.length,
                                            <Popover
                                                title={
                                                    <span
                                                        className="font-bold text-sm text-color-000">{t('list of lesson')}</span>
                                                }
                                                content={
                                                    <div className="flex flex-col gap-1 m-2">
                                                        {attendances.map((e, i) => (
                                                            <div key={i} className="flex items-center gap-6 italic">
                                              <span className="font-medium text-sm text-color-100">
                                                  {`${i + 1}. ${e.title}`}
                                              </span>
                                                                <span className="font-medium text-xs text-color-100">
                                                  <span className="font-normal text-color-400">
                                                      {`${t('in attendance')} : `}
                                                  </span>
                                                                    {`${e.total_attendance}/${e.total_students}`}
                                              </span>
                                                                {renderIf(
                                                                    (e.total_excused_absence + e.total_unexcused_absence) > 0,
                                                                    <span
                                                                        className="font-medium text-xs text-color-100">
                                                      <span
                                                          className="font-normal text-color-400">{`${t('absence')} : `}</span>
                                                                        {e.total_excused_absence + e.total_unexcused_absence}
                                                  </span>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                }>
                                                <div
                                                    className="flex items-center gap-1 font-medium text-xs text-color-400 hover:text-color-100 italic cursor-pointer">
                                                    <GoDotFill size={10}/> {t('attendance sheet')}
                                                </div>
                                            </Popover>
                                        )}
                                    </div>
                                )}
                            </div>
                            {renderContextMenu(item)}
                        </div>
                    )}
                </Translate>
            )
        }
